
import React, { useEffect, useState } from 'react'
import MainLayout from '../Layouts/Index'
import Seo from '../Utils/Seo'
import { Box, Flex, Select, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import Button from '../Components/Button'
import { GetAllPendingInventory, GetAllPendingStock, GetAllProduct, ScheduleStock, StoreSupervisor, TeamLeadApproval } from '../Utils/ApiCalls'
import StockRow from '../Components/StockRow'
import Preloader from '../Components/Preloader'
import CreateReturnToShelf from '../Components/CreateReturnToShelf'
import { showToast } from '../Utils/tool'
import ColorCode from '../Components/ColorCode'

export default function TeamLeadInventory() {

    const [Shelf, setShelf] = useState();
    const [Data, setData] = useState([]);
    const [isLoading, setisLoading] = useState(false);
    const [Loading, setLoading] = useState(false);
    const { isOpen, setIsOpen } = useState(true);
    const [SingleData, setSingleData] = useState();


    const takeStokeApi = async () => {

        try {
            setisLoading(true)
            let result = await GetAllPendingInventory()
            console.log("object all pending product", result);

            if (result.status === true) {
                setisLoading(false)
                setData(result.queryresult)

            } else {
                setisLoading(false)

            }
        } catch (e) {
            setisLoading(false)

        }
    }


    const [Response, setResponse] = useState({
        approvalresponse: false,
        data: ""
    });

    const Reject = async (id) => {


        try {

            setResponse({
                approvalresponse: false,
                data: [{ _id: id }]
            })

            setLoading(true)
            let result = await StoreSupervisor(Response)
            console.log(" Reject product", result);

            if (result.status === true) {
                setLoading(false)

                showToast({
                    type: 'success',
                    message: " Stock has been Rejected Successfully "
                })
                setIsOpen(!isOpen)
            } else {
                setLoading(false)

            }
        } catch (e) {
            setLoading(false)

        }

    }
    const Approve = async (id) => {


        try {

            setResponse({
                approvalresponse: true,
                data: [{ _id: id }]
            })

            setLoading(true)
            let result = await TeamLeadApproval(Response)
            console.log("Approve product", result);

            if (result.status === true) {
                setLoading(false)

                showToast({
                    type: 'success',
                    message: "Stock has been approved Successfully "
                })

                setIsOpen(!isOpen)

            } else {
                setLoading(false)

            }
        } catch (e) {
            setLoading(false)

        }


    }
    const ApproveAll = async () => {
        let arr = []

        Data.map((item, i) => (
            arr.push({ "_id": item._id })
        ))

        setResponse({
            approvalresponse: true,
            data: arr
        })

        try {
            setLoading(true)
            let result = await TeamLeadApproval(Response)
            console.log("ApproveAll pending product", result);

            if (result.status === true) {
                setLoading(false)

                showToast({
                    type: 'success',
                    message: "All Stock is has been approved Successfully "
                })

                setIsOpen(!isOpen)

            } else {
                setLoading(false)

            }
        } catch (e) {
            setLoading(false)

        }



    }

    console.log("Response", Response)

    useEffect(() => {
        takeStokeApi()
    }, [isOpen, Loading]);

    return (
        <MainLayout>
            <Seo title='Take Stock' description='IMS Take Stock' />
            {
                Loading && (
                    <Preloader />
                )
            }


                <Flex justifyContent={"flex-end"} flexWrap="wrap" fontWeight={"500"} >


                    <Text textTransform="capitalize">Total Pending Inventory Stock - {Data?.length}</Text>

                </Flex>
            <Box display={"block"} pos="relative" alignItems="flex-start" w={"100%"} height="70vh" minH={"70vh"} overflow="auto" _hover={{ overflow: "auto" }} bg="blue.blue200" mt="32px" rounded={"8px"}>
            <ColorCode />

               <Table variant='simple' size='sm' overflowX="auto" color="#fff">
                        <Thead>
                            <Tr>
                                <Th color="#fff">S/N</Th>
                                <Th color="#fff">Product name</Th>
                                <Th color="#fff">CountedGroupQty</Th>
                                <Th color="#fff">ShelfGroupQty</Th>
                                <Th color="#fff">Store</Th>
                                <Th color="#fff">Approve</Th>



                            </Tr>
                        </Thead>
                        <Tbody>

                            {
                                Data?.map((item, i) => (
                                    <StockRow
                                        type={"pendingStock"}
                                        sn={i + 1}
                                        productName={item.productname}
                                        qty={item.countedqty}
                                        serviceable={item.countedqtyserviceable}
                                        unServiceable={item.countedqtyunserviceable}
                                        shelfQty={item.shelfid?.qty}
                                        shelfServiceable={item.shelfid?.qtyserviceable}
                                        shelfUnServiceable={item.shelfid?.qtyunserviceable}
                                        store={item.store}
                                        index={item}
                                        TakeData={Data}
                                        approve={() => Approve(item._id)}
                                        reject={() => Reject(item._id)}
                                    />
                                ))
                            }
                        </Tbody>

                    </Table>
           

                {
                    Data.length > 0 && (

                        <Box pos={"absolute"} w={"100%"} bottom={"0"} cursor="pointer" bg="teal" color="#fff" textAlign={"center"} p="8px" rounded="8px" onClick={ApproveAll}>Approve All</Box>
                    )
                }


            </Box>


        </MainLayout>
    )
}
